import React from 'react';
import { MarkdownText } from '@fullstory/components';

interface ObjectDescriptionProps {
  textStyle: ({ ...props }) => JSX.Element;
  description: string;
}

export const ObjectDescription: React.FC<ObjectDescriptionProps> = function CardTitle({
  textStyle,
  description,
}) {
  return (
    <MarkdownText
      text={description}
      components={{
        h1: textStyle,
        h2: textStyle,
        h3: textStyle,
        h4: textStyle,
        h5: textStyle,
        h6: textStyle,
        p: textStyle,
        li: textStyle,
      }}
    />
  );
};
